<template>
  <div class="enter-order-page">
    <div class="content-box">
      <div class="bg-box1"></div>
      <div class="box1">
        <div class="user-box">
          <div class="flex-row row-between col-end">
            <div>
              <span style="font-size: 14px">收货人：</span>
              <span>张三</span>
            </div>
            <div>1343445354</div>
          </div>
          <div class="flex-row row-between col-center mt12">
            <div>
              <span style="font-size: 14px">收货地址：</span>
              <span>四川省成都市沙市区千路沙龙达艺术</span>
            </div>
            <van-icon class="ml8" name="arrow" style="font-size: 18px;color: #727272"/>
          </div>
        </div>
        <div style="margin-top: 34px">
          <div>包裹1-仓库</div>
          <div class="flex-row" style="margin-top: 27px">
            <img alt="" src="images/test/02.jpeg" style="width: 89px;height: 89px">
            <div class="ml12" style="height: 89px;">
              <div style="font-size: 13px;color: #585858;">{{ goodsDetail.name }}</div>
              <div class="mt8" style="font-size: 11px;color: #585858;">颜色分类：{{ goodsDetail.color }}</div>
              <div class="mt8" style="font-size: 11px;color: #FF8748;">30天无理由退换</div>
              <div class="flex-row row-between col-end" style="width: 240px">
                <div class="mt8" style="font-size: 15px;color: #FF8748;">￥399</div>
                <div style="font-size: 15px;color: #6A6A6A;">X{{ goodsDetail.count }}</div>
              </div>
            </div>
          </div>
          <div style="font-size: 15px;color: #6A6A6A;">
            <div class="flex-row row-between mt22">
              <div>配送方式：</div>
              <div>{{ goodsDetail.distribution === 1 ? '包邮' : '到付' }}</div>
            </div>
            <div class="flex-row row-between mt22">
              <div>运费险：</div>
              <div>￥2</div>
            </div>
            <div class="flex-row row-between mt22">
              <div>运费险投保须知：</div>
              <div></div>
            </div>
            <div class="flex-row mt22">
              <div>买家留言：</div>
              <input class="remark-input" placeholder="填写内容已和卖家商议确认" type="text">
            </div>
            <div class="flex-row row-between mt22">
              <div>商品优惠：</div>
              <div>-12</div>
            </div>
            <div class="flex-row row-end mt22">
              <div>共1件商品</div>
              <div>
                <span>小计：</span>
                <span>￥82</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box4 flex-row col-center row-end">
      <div class="flex-row">
        <div class="flex-row col-center">
          <span style="font-size: 15px">合计: <span style="color: #FF7800;font-size: 12px">￥</span> <span
              style="color: #FF7800">{{ 134 }}</span></span>
        </div>
        <div class="text-center ml8"
             style="height: 50px;width: 115px;background-color: #FC3F3F;color: white;line-height: 50px">
          去结算
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      goodsDetail: {
        id: 1,
        name: '女士休闲帽',
        price: 82,
        count: 1,
        status: 1,
        size: 'L',
        color: '粉色',
        create_time: '2021-04-09 07:46:25',
        distribution: 1
      }
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import "index";
</style>
